import classNames from 'classnames'
import { ContentBadgeProps } from './ContentBadge.types'
import styles from './ContentBadge.module.scss'

const ContentBadge = (props: ContentBadgeProps): JSX.Element => {
  const { children, variant, onClickEvent, ...rest } = props
  return (
    <div
      role="button"
      tabIndex={0}
      data-testid="content-badge"
      className={classNames(styles.wrapper, variant ? styles[variant] : undefined)}
      {...rest}
      onClick={onClickEvent}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClickEvent?.()
        }
      }}
    >
      {children}
    </div>
  )
}
export default ContentBadge
